import { type DrawableMixin } from "./objects/drawable_mixin"
import WithImages from "./with_images"
import ImageObject from "@/signomatic/app/objects/image"
import type SignDrawables from "@/signomatic/app/sign_drawables"

export const PatternPaths: StringMap<string> = {
  threed: "/images/signomatic/patterns/threed.png",
  blue_flowers: "/images/signomatic/patterns/blue_flowers.png",
  blue_jeans: "/images/signomatic/patterns/blue_jeans.png",
  golden_gatsby: "/images/signomatic/patterns/golden_gatsby.png",
}

export default class SignPattern extends WithImages {
  private readonly drawables: SignDrawables
  private readonly imagePath: string

  static create(state: SignState, drawables: SignDrawables) {
    const { pattern } = state

    if (!pattern || pattern === "" || !PatternPaths[pattern]) {
      return null
    }

    return new SignPattern(drawables, PatternPaths[pattern])
  }

  constructor(drawables: SignDrawables, imagePath: string) {
    super()
    this.drawables = drawables
    this.imagePath = imagePath
    this.loadImages()
  }

  drawable(): DrawableMixin | null {
    const { widthPx } = this.drawables.state
    const source = this.image()

    if (this.imagesLoaded && source) {
      return new ImageObject(source).addClass("pattern").scaleToWidth(widthPx)
    }

    return null
  }

  protected redraw() {
    this.drawables.redraw()
  }

  protected imagePaths() {
    return this.imagePath
  }
}
